import api from '@/lib/api';
import type { ApiResponse, DashboardResponse } from '@amuster/types';

export const dashboardService = {
  getSummary() {
    return api.get<ApiResponse<DashboardResponse>>('/dashboard');
  },
};
